<template>
  <div class="sortBox">
    <div class="flex space_between f14 pxtab white">
      <div @click="changeSort('0')" :class="{'main_co': sortType===0}">综合</div>
      <div @click="changeSort('1')">
        <span :class="{'main_co': sortType===1||sortType===2}">销量</span>
        <img v-if="sortType==='1'" src="@/assets/image/common/paixu_z.png" alt="" style="width: 0.16rem">
        <img v-else-if="sortType==='2'" src="@/assets/image/common/paixu_y.png" alt="" style="width: 0.16rem">
        <img v-else src="../assets/image/common/paixu.png" alt="" style="width: 0.16rem">
      </div>
      <div @click="changeSort('2')">
        <span :class="{'main_co': sortType===3||sortType===4}">价格</span>
        <img v-if="sortType==='3'" src="@/assets/image/common/paixu_z.png" alt="" style="width: 0.16rem">
        <img v-else-if="sortType==='4'" src="@/assets/image/common/paixu_y.png" alt="" style="width: 0.16rem">
        <img v-else src="@/assets/image/common/paixu.png" alt="" style="width: 0.16rem">
      </div>
      <div @click="changeSort('3')">
        <span :class="{'main_co': sortType===5||sortType===6}">铜板</span>
        <img v-if="sortType==='5'" src="@/assets/image/common/paixu_z.png" alt="" style="width: 0.16rem">
        <img v-else-if="sortType==='6'" src="@/assets/image/common/paixu_y.png" alt="" style="width: 0.16rem">
        <img v-else src="@/assets/image/common/paixu.png" alt="" style="width: 0.16rem">
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "sortBar",
  props: {
    sortType: {type: Number, default: 0}, //排序方式
  },
  data() {
    return {}
  },
  methods: {
    changeSort(val) {
      console.log("zouss...")
      this.$emit("bindSort", val);
    }
  }
}
</script>
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/sortBar.vue